import React, { useEffect, useState } from 'react'
import { useContext } from 'react';
import AppContext from '../../../../config/AppContext';
import { useTranslation } from 'react-i18next';
import { Box, CircularProgress, IconButton, Typography, useTheme } from '@mui/material';
import dayjs from 'dayjs';
import { getAllSummaryHistory } from '../../../../services/AiService';
import { ReactComponent as DateIcon } from "../../../../assets/images/date-filter-icon.svg";
import { ReactComponent as CalendarIcon } from "../../../../assets/images/ralvie/Calendar.svg";
import { ReactComponent as CalendarIconDark } from "../../../../assets/images/ralvie/CalendarDark.svg";
import "../SummaryAgent.scss";

export default function AISummaryHistory({ setIsDateSelected, setSelectedSummaries, reloadHistory }) {

    const { t, i18n } = useTranslation();
    const [isLoading, setIsLoading] = useState(false);
    const [summaryHistory, setSummaryHistory] = useState([]);
    const [generatedSummary, setGenerateSummary] = useState(undefined);
    const { mode } = useContext(AppContext);
    const [selectedDate, setSelectedDate] = useState(null);


    const loadSummary = () => {
        setIsLoading(true);
        setSummaryHistory([]);
        getAllSummaryHistory()
            .then((res) => {
                if (res.data?.code === "RCI0000") {
                    setSummaryHistory(res.data.data);
                } else {
                    setSummaryHistory([]);
                }
                setIsLoading(false);
            })
            .catch((err) => {
                setIsLoading(false);
            });
    };

    useEffect(() => {
        loadSummary();
    }, [reloadHistory]);

    return (
        <Box>
            {isLoading && <Box
                width={'100%'}
                height={'100%'}
                mt={10}
                display={'flex'}
                justifyContent={'center'}>
                <CircularProgress size={35} />
            </Box>}
            {!isLoading &&
                <Box mt={2}
                    display={'flex'}
                    flexDirection={'column'}
                    justifyItems={'start'}
                    alignItems={'start'}
                >
                    {Object.keys(summaryHistory).length !== 0 ?
                        (Object.entries(summaryHistory).map(([date, items], index) => (
                            <div key={date}
                                onClick={() => {
                                    setIsDateSelected(true);
                                    setSelectedSummaries([]);
                                    setSelectedDate(date);
                                    setTimeout(() => {
                                        setSelectedSummaries(items);
                                    }, 500);
                                }}
                                className={`${mode === "dark" ? 'summarization-history1Dark' : 'summarization-history1'} ${selectedDate === date ? 'selected' : ''}`}
                            >
                                <Box
                                    display="flex"
                                    flexDirection="row"
                                    justifyContent="start"
                                    alignItems="center"
                                    gap={1}
                                    // px={2}
                                >
                                 {mode === "dark"?<CalendarIconDark/>:<CalendarIcon/>}
                                    <Typography variant="body1" className='summarization-history11'>
                                        {dayjs(date, 'DD-MM-YYYY').format('Do MMM YYYY')}
                                    </Typography>
                                </Box>
                            </div>
                        ))) : (<>
                            <Box
                                display="flex"
                                justifyContent={'center'}
                                alignItems={"center"}
                                width={'100%'}
                                height={'60vh'}
                            >
                                <Typography variant="" className='summarization-history11'>
                                    {t('RAL1204')}
                                </Typography>
                            </Box>
                        </>)
                    }
                </Box>}
        </Box>
    )
}
